import React from 'react'
import { useStore } from '@UseCase/store';
import * as classes from './index.module.css'
import LogoText from "@Svg/logo.svg";
import LogoShape from "@Svg/logo-shape.svg";
import { Link } from 'gatsby'

const Logo = ({location}) => {

    const [store] = useStore();
    const {scrollPosition, navOpenState} = store;

	return (
		<div className={`${classes.root} ${navOpenState === 'nav' ? classes.navOpened : ''}`}>
			{(location?.pathname === '/') &&
				<h1 className={classes.logo}>
					<span className="sr-only">Jungle creations</span>
					<LogoText className={`${classes.logoText} ${scrollPosition > 100 ? classes.LogoTextHidden : classes.LogoTextShow}`} />
                    <LogoShape className={`${classes.logoShape} ${scrollPosition > 100 ? classes.LogoShapeShow : classes.LogoShapeHidden}`} />
				</h1>
			}
			{(location?.pathname !== '/') &&
				<Link to={`/`} title="Greatsweb" className={classes.logo}>
					<LogoText className={`${classes.logoText} ${scrollPosition > 100 ? classes.LogoTextHidden : classes.LogoTextShow}`} />
                    <LogoShape className={`${classes.logoShape} ${scrollPosition > 100 ? classes.LogoShapeShow : classes.LogoShapeHidden}`}/>
				</Link>
			}
		</div>
	)
}

export default Logo